import { render, staticRenderFns } from "./SwitcherView.vue?vue&type=template&id=49b988f1&scoped=true"
import script from "./SwitcherView.vue?vue&type=script&lang=js"
export * from "./SwitcherView.vue?vue&type=script&lang=js"
import style0 from "./SwitcherView.vue?vue&type=style&index=0&id=49b988f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b988f1",
  null
  
)

export default component.exports